<template>
  <div>
    <v-card flat>
      <v-expansion-panels v-model="panel" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header class="font-weight-bold">Select Condition</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense class="ma-0">
              <v-col cols="6" sm="6" md="4" class="mt-2">
                <v-select
                  label="Department"
                  v-model="deptName"
                  :items="deptNameList"
                  outlined
                  dense
                  @change="groupList"
                />
              </v-col>

              <v-col cols="6" sm="6" md="4" class="mt-2">
                <v-select
                  label="Group"
                  v-model="respName"
                  :items="respNameList"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="6" sm="6" md="4" class="mt-2">
                <v-text-field
                  label="ID/Name/ID Card"
                  v-model="search"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                  @keyup="uppercase"
                  @keyup.enter="btnRetrieve"
                />
              </v-col>

              <v-col cols="6" sm="6" md="4">
                <v-btn
                  v-show="!isMobileDevice" 
                  height="40"
                  class="mt-2"
                  block
                  color="success"
                  @click="btnRetrieve"
                >
                  <v-icon left>{{ icons.mdiMapSearch }}</v-icon>
                  Retrieve
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-card max-width="auto" class="mx-auto mt-2">
      <!-- class="no-scrollbar-scroll" Khong muốn hiển thị thanh bar-->
        <v-virtual-scroll
            :items="sortedArray"
            :item-height="200"
            :height="isMobileDevice ? undefined : 700"
            bench="6"
            
        >
            <template v-slot:default="{ item }">
                <v-list-item 
                    :key="item.empNo" 
                    @click="showDetail(item)" 
                    @mouseover="onListItemHover(item)"
                    class="pa-4"
                >
                    <v-list-item-avatar height="120" width="90" tile class="elevation-1 mr-4">
                      <v-fade-transition mode="out-in">
                        <v-img 
                          v-if="item.empPic" 
                          :key="item.empNo + 'img'"
                          :src="item.empPic" 
                        />
                        <v-icon 
                          v-else 
                          :key="item.empNo + 'icon'"
                          size="60" 
                          color="grey lighten-2" 
                          class="grey lighten-4" 
                          style="width:100%; height:100%"
                        >
                          mdi-account
                        </v-icon>
                      </v-fade-transition>
                    </v-list-item-avatar>
                    
                    <v-list-item-content>
                    <v-list-item-title class="text-h5 font-weight-bold primary--text mb-1 ">
                         <span class="font-weight-bold text-uppercase">NAME: {{ item.sbnEngnm }} </span>
                    </v-list-item-title>

                    <v-list-item-subtitle class="grey--text text--darken-4 mb-2 ">
                        <span class="font-weight-bold">HVS ID:</span> {{ item.sbn }} 
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="grey--text text--darken-4 mb-2 ">
                        <span class="font-weight-bold">ID NO:</span> {{ item.cccd }}
                    </v-list-item-subtitle>

                    <v-divider class="mb-2"></v-divider>

                    <div class="blue--text text--darken-4 font-weight-bold body-2 ">
                        <span class="font-weight-bold">CERT NO:</span> {{ item.certNo }}
                    </div>

                    <div class="caption grey--text text--darken-2 ">
                        <span class="font-weight-bold">PROCESS:</span> {{ item.process }}
                    </div>
                    <div class="caption grey--text text--darken-2 ">
                        <span class="font-weight-bold">POSITION:</span> {{ item.pos }}
                    </div>

                    <v-divider class="mb-2"></v-divider>

                    <div class="caption red--text font-italic font-weight-bold mt-1 ">
                        {{ item.certDate }}
                    </div>
                    </v-list-item-content>

                    <v-list-item-action>
                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
            </template>
        </v-virtual-scroll>
    </v-card>

    <v-dialog v-model="dialog" max-width="450" persistent transition="dialog-bottom-transition">
      <v-card style="max-height: 90vh;" class="d-flex flex-column overflow-hidden">
        
        <v-card-title class="blue white--text justify-center flex-grow-0 ma-0 pa-2">
          <v-spacer></v-spacer>
          <h5 class="ma-0">WELDER'S QUALIFICATION</h5>
          <v-spacer></v-spacer>
            <v-btn
            v-if="isMobileDevice"
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <div class="flex-grow-1 yellow lighten-4" style="overflow-y: auto; position: relative;">
          <DxScrollView 
            height="100%" 
            width="100%"
            direction="vertical"
            :use-native="false"
            show-scrollbar="never"
            :scroll-by-content="true"
            :scroll-by-thumb="false"
          >
            <div class="pa-0">
              <v-card-text class="pa-4 text-center">
                <p class="font-weight-bold mb-0">This person has been qualified by classification for ships as welder/welding operator.</p>
              </v-card-text>

              <v-list-item v-for="(info, idx) in gridMainInfo" :key="'info-'+idx" class="px-4">
                <v-avatar class="ma-2 elevation-1" height="120" width="90" tile>
                  <v-img :src="info.empPic" />
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase">NAME: {{ info.enm }}</v-list-item-title>
                  <v-list-item-subtitle>HVS ID: {{ info.sbn }}</v-list-item-subtitle>
                  <v-list-item-subtitle>ID NO: {{ info.cccd }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-data-table
                :headers="dialogActionHeaders"
                :items="gridMainDetailList"
                hide-default-footer
                dense
                class="elevation-0 custom-grid-table yellow lighten-4"
                :item-class="getRowClass"
              />
              
              <div style="height: 20px;"></div>
            </div>
          </DxScrollView>
        </div>

        <div class="flex-grow-0 white border-top">
            <v-card-text class="yellow lighten-4 text-center pa-2">
                <div v-for="(info, idx) in gridMainInfo" :key="`date-${idx}`">
                    <h4 class="mb-1" style="font-size: 0.85rem;">ISSUE DATE: {{ info.issDate }}</h4>
                    <div class="d-flex justify-center mb-1">
                        <v-img :src="require(`@/assets/images/bg/hd_hvs.png`)" contain max-width="150" height="30" />
                    </div>
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-2">
                <v-btn color="indigo" block dark large depressed @click="dialog = false">CLOSE</v-btn>
            </v-card-actions>
        </div>

      </v-card>
    </v-dialog>    
    <v-btn v-scroll="onScroll" v-show="fab && isMobileDevice" fab dark fixed bottom right color="primary" @click="toTop">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiMapSearch } from '@mdi/js'
import { getDeptList, getRespList } from '@/api/view/tqm/80/v80comm.js'
import { v80welderList, v80welderDetailList, v80welderInfo, getBlobToImg } from '@/api/view/tqm/80/v80welder.js'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { DxScrollView } from "devextreme-vue/scroll-view"
import EventBus from '@/components/event-bus';

export default {
  name: "welder",
  mixins: [baseview, BaseDataGrid],
  components: { DxScrollView },
  data: () => ({
    selected: null,
    fab: false,
    dialog: false,
    panel: [0],
    icons: { mdiMapSearch },
    isMobileDevice: false, // Biến mới

    gridMainList: [],
    gridMainInfo: [],
    gridMainDetailList: [],
    
    deptName: '',
    deptNameList: [],
    deptCd: '',
    respName: '',
    respNameList: [],
    respCd: '',
    search: '',

    dialogActionHeaders: [
      { text: 'Cert No', value: 'cerNo', class: 'blue lighten-4', sortable: false, align: 'center' },
      { text: 'Process', value: 'process', class: 'blue lighten-4', sortable: false, align: 'center' },
      { text: 'Position', value: 'pos', class: 'blue lighten-4', sortable: false, align: 'center' },
      { text: 'Class', value: 'classify', class: 'blue lighten-4', sortable: false, align: 'center' }
    ]
  }),

  computed: {
    sortedArray() {
      return [...this.gridMainList].sort((a, b) => a.seq - b.seq);
    }
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      // console.log('click this.checkMobile', this.checkMobile);
      
      this.btnRetrieve();
    });
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.initData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },

  methods: {
    checkMobile() {
      this.isMobileDevice = window.innerWidth <= 800;
      // console.log('this.isMobileDevice', this.isMobileDevice);
      
    },
    onScroll(e) {
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    uppercase() {
      this.search = this.search?.toUpperCase() || '';
    },
    
    async initData() {
      try {
        this.openLoading('Loading departments...');
        const userDept = this.$store.state.user.deptCd;
        
        if (userDept !== 'ZN' && userDept !== 'ZB') {
          const deptLabel = `${userDept} : ${this.$store.state.user.deptNm}`;
          this.deptNameList = [deptLabel];
          this.deptName = deptLabel;
          this.deptCd = userDept;
        } else {
          const res = await getDeptList({ deptCd: '' });
          this.deptNameList = ['All', ...res.list.map(e => `${e.deptCd} : ${e.deptNm}`)];
          this.deptName = 'All';
        }
        await this.groupList();
      } finally {
        this.endLoading();
      }
    },

    async groupList() {
      this.respNameList = ['All'];
      this.deptCd = this.deptName === 'All' ? 'All' : this.deptName.split(' : ')[0];
      
      const params = { deptCd: this.deptCd === 'All' ? '' : this.deptCd };
      const res = await getRespList(params);
      if (res?.list) {
        this.respNameList.push(...res.list.map(e => `${e.respCd} : ${e.respNm}`));
      }
      this.respName = 'All';
    },
    async btnRetrieve() {
        try {
        this.openLoading('Searching...');
        this.gridMainList = [];
        this.respCd = this.respName === 'All' ? '' : this.respName.split(' : ')[0];

        const params = {
            deptCd: this.deptCd === 'All' ? '' : this.deptCd,
            respCd: this.respCd === 'All' ? '' : this.respCd,
            empNo: this.search || ''
        };

        if (this.deptCd == 'All') {
          this.vToastify(this.$t('Sorry!, Select a Department!'), 'warn')
          return
        } 

        const res = await v80welderList(params);
        
            // Trong hàm btnRetrieve
            this.gridMainList = res.list.map((e, index) => ({
                ...e,
                seq: index,
                empNo: e.sbn,
                sbn: e.sbn,
                cccd: e.cccd || e.idNo,
                sbnEngnm: e.sbnEngnm, // Tên sạch, không kèm chữ "NAME:"
                certNo: e.certNo,      // Số cert sạch
                certDate: `ISSUE DATE: ${e.certDate}`,
                process: e.process,
                pos: e.pos,
                empPic: null 
            }));

            // console.log('this.gridMainList.length', this.gridMainList.length);
            
            if (this.gridMainList.length > 0 && this.isMobileDevice == true){
                this.panel = []
            }

        } finally {
        this.endLoading();
        }
    },
    
    // Hàm này được gọi khi người dùng rê chuột vào list item
    async onListItemHover(item) {
      // Chỉ tải nếu chưa có ảnh và chưa từng tải thành công
      if (item.empPic || item._isFetching) return;

      item._isFetching = true; // Cờ tạm để tránh gọi API liên tục khi rê chuột rung
      try {
        const imgRes = await getBlobToImg({ empNo: item.empNo });
        if (imgRes && imgRes.body) {
          // Dùng $set để Vue nhận diện được sự thay đổi dữ liệu trong mảng
          this.$set(item, 'empPic', imgRes.body);
        }
      } catch (err) {
        console.error("Lỗi tải ảnh:", err);
      } finally {
        item._isFetching = false;
      }
    },
    async showDetail(item) {
      this.dialog = true;
      this.getMainInfo(item);
      this.getMainDetailList(item);
    },

    async getMainDetailList(e) {
      const res = await v80welderDetailList({
        deptCd: e.deptCd,
        respCd: e.grpCd,
        empNo: e.empNo
      });
      this.gridMainDetailList = res.list || [];
    },

    async getMainInfo(e) {
      const res = await v80welderInfo({ empNo: e.empNo });
      this.gridMainInfo = await Promise.all(res.list.map(async (info) => {
        const imgRes = await getBlobToImg({ empNo: info.sbn });
        return {
          sbn: info.sbn,
          cccd: info.cccd,
          enm: info.sbnEngnm,
          issDate: info.certDate,
          empPic: imgRes.body
        };
      }));
    },
    getRowClass(item) {
      // Nếu trong danh sách có nhiều Cert No, 
      // ta có thể dùng logic kiểm tra để kẻ line đỏ cho hàng đầu tiên
      return 'cert-row-line'; 
    },
  },
  
}
</script>

<style scoped>
/* 1. Fix lỗi chồng hàng cho Virtual Scroll danh sách bên ngoài */
.v-list-item {
  height: 200px !important; /* Phải khớp với :item-height ở trên template */
  display: flex !important;
  align-items: center !important;
}

/* 2. Fix khoảng trắng PC (Mũi tên đỏ) và ẩn Scrollbar */
/* Tác động sâu vào cấu trúc của DevExtreme */
::v-deep .dx-scrollable-container {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important;  /* IE/Edge */
}

::v-deep .dx-scrollable-container::-webkit-scrollbar {
  display: none !important; /* Chrome/Safari */
  width: 0 !important;
}

@media (min-width: 601px) {
  /* Loại bỏ gutter (khoảng trống scrollbar) của DevExtreme */
  ::v-deep .dx-scrollable-content {
    padding-right: 0 !important;
    margin-right: 0 !important;
  }
  
  ::v-deep .dx-scrollview-content {
    width: 100% !important;
    padding: 0 !important;
  }

  /* Thay vì ép cao 90vh, ta để nó tự nhiên nhưng giới hạn tối đa */
  .v-dialog > .v-card {
    height: auto !important; 
    display: block !important;
  }
  
  /* Đảm bảo phần chứa bảng không bị ép chiều cao */
  .flex-grow-1 {
    flex: 1 1 auto !important;
  }
}

/* Xóa bỏ khoảng trống thừa ở cuối cùng của nội dung bên trong */
.pa-0 > div:last-child {
  height: 10px !important; /* Giảm cái <div style="height: 20px;"></div> xuống */
}

/* 3. Bảng dữ liệu */
.custom-grid-table {
  width: 100% !important;
}

.custom-grid-table >>> .v-data-table__wrapper {
  overflow: visible !important; /* Quan trọng để ScrollView thấy được toàn bộ chiều cao bảng */
}

/* Kẻ bảng dọc */
.custom-grid-table >>> thead th,
.custom-grid-table >>> tbody td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.custom-grid-table >>> th:last-child,
.custom-grid-table >>> td:last-child {
  border-right: visible !important;
}

/* 4. Line xanh cho Mobile (như trong code bạn đang viết màu #22f722) */
@media (max-width: 600px) {
  .custom-grid-table >>> tbody tr.cert-row-line {
    border-top: 3px solid #22f722 !important;
  }
  .custom-grid-table >>> tbody tr.cert-row-line:first-child {
    border-top: 0.5px solid rgba(0, 0, 0, 0.12) !important;
    border-top: visible !important;
  }
}

</style>